import { gql } from "apollo-boost";

export const QUERY_CURRENT_USER = gql`
{
  currentUser{
      email
      is_admin
  }
}
`;